/**
 * Auth context and its hook.
 *
 * Separate from the provider component so each module exports one kind of thing, which is
 * what React Fast Refresh requires to hot-reload either of them.
 */
import { createContext, useContext } from 'react';
import type { Session, User } from '@supabase/supabase-js';

export interface AuthState {
  session: Session | null;
  user: User | null;
  /** True until the initial session read resolves, so the app does not flash the login page. */
  loading: boolean;
  mustChangePassword: boolean;
  signIn: (email: string, password: string) => Promise<{ error: string | null }>;
  signOut: () => Promise<void>;
  changePassword: (next: string) => Promise<{ error: string | null }>;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
}
